/**
 * Labstep
 *
 * @module core/QRCode
 * @desc QRCode wrapper around qrcode.react
 */

import ReactQRCode from 'qrcode.react';
import React from 'react';
import styles from './styles.module.scss';
import type { IQRCodeProps } from './types';

const CANVAS_SELECTOR = '#qrcode > canvas';

export class QRCode extends React.Component<IQRCodeProps> {
  static defaultProps = {
    name: 'labstep',
    download: true,
  };

  downloadRef: any;

  constructor(props: IQRCodeProps) {
    super(props);
    this.handleDownloadClick = this.handleDownloadClick.bind(this);
  }

  handleDownloadClick() {
    const { name } = this.props;
    const canvas: HTMLCanvasElement =
      document.querySelector(CANVAS_SELECTOR);
    this.downloadRef.href = canvas.toDataURL();
    this.downloadRef.download = `${name}-qrcode.png`;
  }

  render() {
    const { download, name, ...rest } = this.props;
    return (
      <div id="qrcode" className={styles.container}>
        <ReactQRCode {...rest} />
        <br />
        <div>
          <a
            onClick={this.handleDownloadClick}
            ref={(ref: any): any => (this.downloadRef = ref)}
          >
            <span>Print QR Code</span>
          </a>
        </div>
      </div>
    );
  }
}
